<template>
  <div class="welcome">
    <!-- <img src="@/assets/welcome.jpg" alt="" /> -->
    <van-swipe :autoplay="5000" lazy-render touchable>
      <van-swipe-item v-for="image in imageList" :key="image.id">
        <img :src="image.fullFilePath" />
      </van-swipe-item>
    </van-swipe>
    <input
      type="text"
      ref="input"
      class="box"
      focus
      v-model="KeyCard"
      @keyup.enter="swipingCard"
    />
    <!-- <div class="code flex flex-center">手牌感应区</div> -->
  </div>
</template>

<script>
import { inputKeyNo,ReadCard } from "@/utils/recycler";
import axios from "axios";
export default {
  name: "welcome",
  data() {
    return {
      KeyCard: "",
      timer: null,
      imageList:[],
      recyclerValue:0,// 自助机程序是否启用手牌回收箱
    };
  },
  watch: {
    KeyCard: {
      handler: function (val, oldVal) {
        this.$refs.input.focus();
      },
      deep: true,
    },
  },
  created() {
    this.getConsumptionAreaId();
  },
  mounted() {
    this.$refs.input.focus();
    this.getStoreSetting()
    // 自助机程序是否启用手牌回收箱
    this.getRecycler()
  },
  methods: {
    swipingCard() {
      if(this.KeyCard){
        this.getSingleByCode(this.KeyCard);
      }
      this.KeyCard = "";
      this.$refs.input.focus();
    },
    getStoreSetting(){
      this.$fetchNo(this.Api.getStoreSetting).then(res =>{
        if(res.data.storeSettingFiles.length>0){
          this.imageList = res.data.storeSettingFiles.filter(item => item.fileBusinessType == 2).sort((a, b) => a.sort - b.sort)
        }
        console.log(this.imageList)
      })
    },
    getSingleByCode(KeyCard) {
      this.$fetchNo(this.Api.examineKeyCard, { KeyCard }).then(
        (res) => {
          if (res.data.length > 0) {
            const { consumptionSubjectId, keyCard } = res.data[0];
            localStorage.setItem("keyCard", keyCard);
            localStorage.setItem("consumptionSubjectId", consumptionSubjectId);
            if(this.recyclerValue==1){
              inputKeyNo(keyCard).then(() =>{
                this.$router.push("/list");
              });
            }else{
              this.$router.push("/list");
            }
            
            // this.$router.push("/home");
          }else{
            this.$toast('该手牌暂无数据，请更换手牌')

            //打开参数后，继续读卡
            if(this.recyclerValue==2){
              this.readCard();
            }
          }
        }
      );
    },
    getConsumptionAreaId() {
      this.$fetchNo(this.Api.userInfo).then((res) => {
        let dataList = res.data.filter((item) => item.isDefault);
        if (dataList.length > 0) {
          localStorage.setItem(
            "consumptionAreaId",
            dataList[0].consumptionAreaId
          );
        } else {
          localStorage.setItem(
            "consumptionAreaId",
            res.data[0].consumptionAreaId
          );
        }
      });
    },
    // 自助机程序是否启用手牌回收箱
    getRecycler() {
      this.$fetchNo(this.Api.getSettingCode + "/001006005").then((res) => {
        if(res.data.value == "1" && localStorage.getItem("type") == "自助结账"){
          this.recyclerValue = 1;
          console.log('001006005==',this.recyclerValue);
        }
        //HS32手环回收机
        this.$fetchNo(this.Api.getSettingCode + "/001005007").then((res2) => {
          if(res2.data.value == "1" && localStorage.getItem("type") == "自助结账"){
            this.recyclerValue = 2;
            console.log('001005007==',this.recyclerValue);
            // 启动递归定时器，第一次调用readCard
            this.readCard();
          }
        });

      });
    },
    readCard() {
      axios.get(`http://localhost:6001/api/BraceletRecycle/ReadCard`,
        {
          skipGlobalErrorHandling: true
        }
      ).then(res => {
        console.log('ReadCard==',res);
        this.getSingleByCode(res.data.data);
      }).catch(error => {
        setTimeout(this.readCard, 1000)
      })
    },
  },
};
</script>

<style lang="less" scoped>
.welcome {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  .box {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9;
    background: transparent;
    font-size: 1px;
    color: transparent;
  }
  img {
    width: 100vw;
    height: 100vh;
  }
  .code {
    width: 886px;
    height: 140px;
    font-size: 40px;
    font-weight: 700;
    color: #fff;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 16px;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    bottom: 110px;
  }
}
</style>